<template>
  <div class="container">
    <a-spin :spinning="loading" size="large" class="loading-spin" />
    
    <div class="cms fade-in">
      <!-- 头部区域 -->
      <div class="cms-header">
        <h1 class="cms-title">{{ cmsInfo.cmsTitile }}</h1>
        <div class="cms-info">
          <div class="info-item">
            <a-icon type="clock-circle" class="info-icon" />
            <span>本文发布于：{{ cmsInfo.createTime }}</span>
          </div>
        </div>
      </div>

      <!-- 主体内容区 -->
      <div class="article-content fade-in-delay" v-html="cmsInfo.cmsContent"></div>
      
      <!-- 附件区域 -->
      <div class="extra-file fade-in-delay-2" v-if="cmsInfo.extraFile">
        <div class="file-header">
          <a-icon type="paper-clip" class="file-icon" />
          <span class="file-title">附件下载</span>
        </div>
        <div class="file-list">
          <div 
            class="file-item" 
            v-for="(v,i) in extraFiles" 
            :key="i"
            @click="handleFileClick(v.url)"
          >
            <div class="file-number">{{ i + 1 }}</div>
            <div class="file-info">
              <a-icon type="file" class="file-type-icon" />
              <span class="file-name">{{ v.fileName }}</span>
            </div>
            <a-icon type="download" class="download-icon" />
          </div>
        </div>
      </div>
    </div>

    <!-- 评论区 -->
    <a-card :bordered="false" class="comment-card fade-in-delay-3" v-if="false && cmsInfo.canReply == 1">
      <div class="project-comment">
        <div class="comment-header">
          <a-icon type="message" class="comment-header-icon" />
          <span class="comment-header-title">评论区</span>
        </div>
        
        <div class="publish">
          <a-row type="flex" justify="space-between" :gutter="16">
            <a-col :span="3" class="comment-user">
              <a-avatar
                shape="square"
                :size="60"
                icon="user"
                :src="avatarUrl"
                class="user-avatar"
              />
              <p class="user-name">
                {{
                  $store.state.user.info && $store.state.user.info.realname
                    ? $store.state.user.info.realname
                    : "未登录"
                }}
              </p>
            </a-col>
            <a-col :span="16">
              <a-textarea
                v-model="commentContent"
                :rows="5"
                :maxLength="500"
                placeholder="说说你的想法吧..."
                class="comment-textarea"
              ></a-textarea>
            </a-col>
            <a-col :span="4">
              <div class="comment-btn">
                <a-button 
                  :disabled="!token" 
                  type="primary" 
                  size="large"
                  block
                  @click="comment"
                  class="submit-btn"
                >
                  <a-icon type="send" />
                  发表评论
                </a-button>
              </div>
            </a-col>
          </a-row>
        </div>
        
        <a-divider class="comment-divider" />
        
        <a-list
          class="comment-list"
          item-layout="horizontal"
          :locale="{ emptyText: '暂无评论，快来发表第一条评论吧~' }"
          :data-source="comments"
        >
          <a-list-item slot="renderItem" slot-scope="item" class="comment-item">
            <a-comment
              :author="item.nickname || item.realname || item.username"
              class="comment-wrapper"
            >
              <a-avatar
                shape="square"
                :size="40"
                slot="avatar"
                icon="user"
                :src="item.avatar"
                class="comment-avatar"
              />
              <p class="comment-content" slot="content">
                {{ item.comment }}
              </p>
              <a-tooltip
                slot="datetime"
                :title="moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')"
              >
                <span class="comment-time">{{ moment(item.createTime).fromNow() }}</span>
              </a-tooltip>
            </a-comment>
          </a-list-item>
          <div
            v-if="showLoadingMore"
            slot="loadMore"
            class="load-more-wrapper"
          >
            <a-spin v-if="loadingMore" />
            <a-button type="link" v-else @click="workComments" class="load-more-btn">
              <a-icon type="down" />
              加载更多
            </a-button>
          </div>
        </a-list>
      </div>
    </a-card>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import { getAction, postAction } from "@/api/manage";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      cmsInfo: {},
      extraFiles: [],
      commentContent: "",
      showLoadingMore: true,
      loadingMore: false,
      commentsPage: 0,
      comments: [],
      token: "",
    };
  },
  computed: {
    avatarUrl() {
      if (this.$store.state.user.info && this.$store.state.user.info.avatar) {
        return this.$store.state.user.info.avatar;
      } else {
        return "/img/avatar.png";
      }
    },
  },
  watch: {
    $route(to, from) {
      this.getCmsDetail();
    },
  },
  created() {
    this.token = Vue.ls.get(ACCESS_TOKEN);
    this.getCmsDetail();
  },
  methods: {
    ...mapGetters(["nickname", "avatar", "userInfo"]),
    moment,
    getCmsDetail() {
      this.loading = true;
      getAction(
        "/teaching/teachingCms/getCmsDetail?id=" + this.$route.query.id
      ).then((res) => {
        if (res.success) {
          this.cmsInfo = res.result;
          if(this.cmsInfo.extraFile){            
            this.extraFiles = this.cmsInfo.extraFile_fileinfo instanceof Array ? this.cmsInfo.extraFile_fileinfo : [this.cmsInfo.extraFile_fileinfo]
          }
          //this.workComments();
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    handleFileClick(url) {
      window.open(url, '_blank');
    },
    workComments() {
      this.commentsPage += 1;
      this.loadingMore = true;
      getAction("/teaching/comment/queryCommentBySourceId", {
        id: this.cmsInfo.id,
        page: this.commentsPage,
      }).then((res) => {
        this.loadingMore = false;
        if (res.result.length == 0 && this.commentsPage > 1) {
          this.$message.info("已加载完啦！");
        } else {
          this.comments = this.comments.concat(res.result);
        }
      });
    },
    comment() {
      if (this.commentContent != "") {
        postAction("/teaching/comment/saveComment", {
          sourceType: '2',
          sourceId: this.cmsInfo.id,
          comment: this.commentContent,
        }).then((res) => {
          if (res.success) {
            this.comments.unshift({
              comment: this.commentContent,
              realname: this.$store.state.user.info.realname,
              avatar: this.avatarUrl,
              createTime: new Date(),
            });
            this.commentContent = "";
            this.$message.success(res.message);
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
// 动画定义
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

.container {
  max-width: 1200px;
  margin: 24px auto;
  padding: 0 20px;
  position: relative;
  min-height: 100vh;

  .loading-spin {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
  }
}

// 淡入动画类
.fade-in {
  animation: fadeIn 0.6s ease-out;
}

.fade-in-delay {
  animation: fadeIn 0.6s ease-out 0.2s both;
}

.fade-in-delay-2 {
  animation: fadeIn 0.6s ease-out 0.4s both;
}

.fade-in-delay-3 {
  animation: slideInRight 0.6s ease-out 0.6s both;
}

.cms {
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  min-height: 80vh;
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  }
}

.cms-header {
  text-align: center;
  padding: 50px 40px 30px;
  position: relative;
  background: linear-gradient(180deg, rgba(102, 126, 234, 0.03) 0%, transparent 100%);

  .cms-title {
    font-size: 36px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 50px 24px;
    line-height: 1.4;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    transition: all 0.3s ease;
  }

  .cms-info {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;

    .info-item {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #666;
      font-size: 15px;
      padding: 8px 16px;
      background: #f8f9fa;
      border-radius: 20px;
      transition: all 0.3s ease;

      &:hover {
        background: #e9ecef;
        transform: translateY(-2px);
      }

      .info-icon {
        color: #667eea;
        font-size: 16px;
        animation: float 3s ease-in-out infinite;
      }
    }
  }
}

.article-content {
  overflow: auto;
  padding: 40px 100px;
  color: #555;
  line-height: 2;
  font-size: 16px;
  transition: all 0.3s ease;

  /deep/ img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    margin: 20px 0;

    &:hover {
      transform: scale(1.02);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    }
  }

  /deep/ p {
    margin-bottom: 16px;
    color: #555;
  }

  /deep/ h1, /deep/ h2, /deep/ h3, /deep/ h4, /deep/ h5, /deep/ h6 {
    color: #333;
    margin-top: 24px;
    margin-bottom: 16px;
    font-weight: 600;
  }

  /deep/ ul, /deep/ ol {
    padding-left: 24px;
    margin-bottom: 16px;
  }

  /deep/ li {
    margin-bottom: 8px;
  }

  /deep/ strong {
    color: #333;
    font-weight: 600;
  }

  /deep/ code {
    background: #f5f5f5;
    padding: 2px 6px;
    border-radius: 4px;
    font-family: 'Courier New', monospace;
    color: #e83e8c;
  }

  /deep/ blockquote {
    border-left: 4px solid #667eea;
    padding-left: 16px;
    margin: 20px 0;
    color: #666;
    font-style: italic;
    background: rgba(102, 126, 234, 0.05);
    padding: 16px;
    border-radius: 4px;
  }

  /deep/ a {
    color: #667eea;
    text-decoration: none;
    transition: all 0.3s ease;

    &:hover {
      color: #764ba2;
      text-decoration: underline;
    }
  }
}

.extra-file {
  padding: 30px 100px 40px;
  margin-top: 20px;

  .file-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid #f0f0f0;

    .file-icon {
      color: #667eea;
      font-size: 20px;
      animation: float 2s ease-in-out infinite;
    }

    .file-title {
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }
  }

  .file-list {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .file-item {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 16px 20px;
      background: #f8f9fa;
      border-radius: 12px;
      cursor: pointer;
      transition: all 0.3s ease;
      border: 2px solid transparent;

      &:hover {
        background: linear-gradient(90deg, rgba(102, 126, 234, 0.1) 0%, #f8f9fa 100%);
        border-color: #667eea;
        transform: translateX(8px);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
      }

      .file-number {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: #fff;
        border-radius: 50%;
        font-weight: 600;
        font-size: 14px;
        flex-shrink: 0;
      }

      .file-info {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 12px;

        .file-type-icon {
          color: #667eea;
          font-size: 20px;
        }

        .file-name {
          color: #333;
          font-size: 15px;
          font-weight: 500;
        }
      }

      .download-icon {
        color: #667eea;
        font-size: 18px;
        transition: all 0.3s ease;
      }

      &:hover .download-icon {
        transform: translateY(-2px) scale(1.2);
        color: #764ba2;
      }
    }
  }
}

.comment-card {
  margin-top: 24px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover {
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  }

  /deep/ .ant-card-body {
    padding: 30px;
  }
}

.project-comment {
  .comment-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 3px solid;
    border-image: linear-gradient(90deg, #667eea 0%, #764ba2 100%) 1;

    .comment-header-icon {
      color: #667eea;
      font-size: 24px;
      animation: float 2s ease-in-out infinite;
    }

    .comment-header-title {
      font-size: 20px;
      font-weight: 600;
      color: #333;
    }
  }

  .publish {
    margin-bottom: 24px;

    .comment-user {
      text-align: center;
      padding-top: 10px;

      .user-avatar {
        transition: all 0.3s ease;
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);

        &:hover {
          transform: scale(1.1) rotate(5deg);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
        }
      }

      .user-name {
        margin-top: 12px;
        color: #666;
        font-size: 14px;
        font-weight: 500;
      }
    }

    .comment-textarea {
      border-radius: 8px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #667eea;
        box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
      }
    }

    .comment-btn {
      padding-top: 10px;

      .submit-btn {
        height: auto;
        padding: 12px 24px;
        border-radius: 8px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
        transition: all 0.3s ease;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;

        &:hover:not(:disabled) {
          background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
          transform: translateY(-2px);
        }

        &:active:not(:disabled) {
          transform: translateY(0);
        }

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }
    }
  }

  .comment-divider {
    margin: 24px 0;
  }

  .comment-list {
    .comment-item {
      padding: 20px;
      border-bottom: 1px solid #f0f0f0;
      transition: all 0.3s ease;
      border-radius: 8px;
      margin-bottom: 8px;

      &:hover {
        background: #f8f9fa;
        transform: translateX(4px);
      }

      &:last-child {
        border-bottom: none;
      }

      .comment-wrapper {
        width: 100%;

        .comment-avatar {
          transition: all 0.3s ease;
        }

        &:hover .comment-avatar {
          transform: scale(1.1);
        }
      }

      .comment-content {
        color: #555;
        line-height: 1.8;
        font-size: 15px;
        margin: 8px 0;
        word-break: break-word;
      }

      .comment-time {
        color: #999;
        font-size: 13px;
      }
    }
  }

  .load-more-wrapper {
    text-align: center;
    margin-top: 20px;
    padding: 16px 0;

    .load-more-btn {
      color: #667eea;
      font-weight: 500;
      transition: all 0.3s ease;
      display: inline-flex;
      align-items: center;
      gap: 6px;

      &:hover {
        color: #764ba2;
        transform: translateY(-2px);
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .article-content,
  .extra-file {
    padding-left: 60px;
    padding-right: 60px;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 12px;
  }

  .cms-header {
    padding: 30px 20px 20px;

    .cms-title {
      font-size: 24px;
      margin: 0 20px 20px;
    }

    .cms-info {
      gap: 12px;

      .info-item {
        font-size: 13px;
        padding: 6px 12px;
      }
    }
  }

  .article-content {
    padding: 24px 20px;
    font-size: 15px;
  }

  .extra-file {
    padding: 24px 20px 30px;

    .file-list .file-item {
      padding: 12px 16px;
      flex-wrap: wrap;
    }
  }

  .project-comment {
    .publish {
      .comment-user {
        margin-bottom: 16px;
      }

      .comment-btn .submit-btn {
        height: auto;
        padding: 10px 20px;
      }
    }
  }
}
</style>